import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type JobState = {
  conversionJobId: string | undefined;
  setConversionJobId: (id: string | undefined) => void;
};

export const useJobStore = create<JobState>()(
  devtools((set) => ({
    conversionJobId: undefined,
    setConversionJobId: (id: string | undefined) =>
      set({ conversionJobId: id }, undefined, 'job/conversion'),
  })),
);
